export class StoreObj {
  customerId: number;
  storeName: string;
  topK: number;
  maxCollectTokens: number
  refresh: boolean;
}
